var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"map"}},[_c('DevicePopup',{ref:"devicepopup",on:{"closePopup":_vm.closeDevicePopup}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }